module.exports = __webpack_public_path__ + "img/avatar.b8607233.jpg";